module.exports = __webpack_public_path__ + "static/media/home2-slider-4.1ca5b6d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home2-slider-4.jpg
// module id = 1151
// module chunks = 33